export const ALERT_EMAIL_TEMPLATES = {
	label: 'Select Template for Borrower Email',
	MIDropEligible: [
		{
			name: 'mi-drop-eligible-email-template',
			label: 'Email Template Image',
			value: 'MI-001',
			id: 0,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652303606/automated-email-templates/MI_Drop_1_600x600.jpg',
		},
		{
			name: 'mi-drop-eligible-email-template',
			label: 'Email Template Image',
			value: 'MI-002',
			id: 1,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652303592/automated-email-templates/MI_Drop_2_600x600.jpg',
		},
		{
			name: 'mi-drop-eligible-email-template',
			label: 'Email Template Image',
			value: 'MI-003',
			id: 2,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652303577/automated-email-templates/MI_Drop_3_600x600.jpg',
		},
		{
			name: 'mi-drop-eligible-email-template',
			label: 'Email Template Image',
			value: 'MI-004',
			id: 3,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1655123006/automated-email-templates/MI_Drop_4_600x600.jpg',
		},
	],
	LoanAnniversary: [
		{
			name: 'loan-anniversary-email-template',
			label: 'Email Template Image',
			value: 'Anni-001',
			id: 0,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652737009/automated-email-templates/updated/600x600_-_Loan_Anniversary.jpg',
		},
		{
			name: 'loan-anniversary-email-template',
			label: 'Email Template Image',
			value: 'Anni-002',
			id: 1,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652737008/automated-email-templates/updated/600x600_-_Loan_Anniversary2.jpg',
		},
		{
			name: 'loan-anniversary-email-template',
			label: 'Email Template Image',
			value: 'Anni-003',
			id: 2,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1722537927/2024_Loan_Anniversary3_v2.jpg',
		},
		{
			name: 'loan-anniversary-email-template',
			label: 'Email Template Image',
			value: 'Anni-004',
			id: 3,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652737008/automated-email-templates/updated/600x600_-_Loan_Anniversary4.jpg',
		},
	],
	Birthday: [
		{
			name: 'birthday-email-template',
			label: 'Email Template Image',
			value: 'Bday-001',
			id: 0,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652736904/automated-email-templates/updated/600x600_-_Birthday.jpg',
		},
		{
			name: 'birthday-email-template',
			label: 'Email Template Image',
			value: 'Bday-002',
			id: 1,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652736904/automated-email-templates/updated/600x600_-_Birthday2.jpg',
		},
		{
			name: 'birthday-email-template',
			label: 'Email Template Image',
			value: 'Bday-003',
			id: 2,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652736904/automated-email-templates/updated/600x600_-_Birthday3.jpg',
		},
		{
			name: 'birthday-email-template',
			label: 'Email Template Image',
			value: 'Bday-004',
			id: 3,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1655122935/automated-email-templates/600x600_-_Birthday4.jpg',
		},
	],
	NewListing: [
		{
			name: 'new-listings-email-template',
			label: 'Email Template Image',
			value: 'List-001',
			id: 0,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652737194/automated-email-templates/updated/600x600_-_New_Listings.jpg',
		},
		{
			name: 'new-listings-email-template',
			label: 'Email Template Image',
			value: 'List-002',
			id: 1,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652737194/automated-email-templates/updated/600x600_-_New_Listings2.jpg',
		},
		{
			name: 'new-listings-email-template',
			label: 'Email Template Image',
			value: 'List-003',
			id: 2,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652737195/automated-email-templates/updated/600x600_-_New_Listings3.jpg',
		},
		{
			name: 'new-listings-email-template',
			label: 'Email Template Image',
			value: 'List-004',
			id: 3,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652737194/automated-email-templates/updated/600x600_-_New_Listings4.jpg',
		},
	],
	CreditWatch: [
		{
			name: 'alert-settings-email-template',
			label: 'Email Template Image',
			value: 'Cred-001',
			id: 0,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652736958/automated-email-templates/updated/600x600_-_Credit_Watch.jpg',
		},
		{
			name: 'alert-settings-email-template',
			label: 'Email Template Image',
			value: 'Cred-002',
			id: 1,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652736958/automated-email-templates/updated/600x600_-_Credit_Watch2.jpg',
		},
		{
			name: 'alert-settings-email-template',
			label: 'Email Template Image',
			value: 'Cred-003',
			id: 2,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652736958/automated-email-templates/updated/600x600_-_Credit_Watch3.jpg',
		},
		{
			name: 'alert-settings-email-template',
			label: 'Email Template Image',
			value: 'Cred-004',
			id: 3,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652736958/automated-email-templates/updated/600x600_-_Credit_Watch4.jpg',
		},
	],
	RateWatch: [
		{
			name: 'email-template',
			label: 'Email Template Image',
			value: 'Rate-001',
			id: 0,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652737238/automated-email-templates/updated/600x600_-_Rate_Watch.jpg',
		},
		{
			name: 'email-template',
			label: 'Email Template Image',
			value: 'Rate-002',
			id: 1,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652737237/automated-email-templates/updated/600x600_-_Rate_Watch2.jpg',
		},
		{
			name: 'email-template',
			label: 'Email Template Image',
			value: 'Rate-003',
			id: 2,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652737238/automated-email-templates/updated/600x600_-_Rate_Watch3.jpg',
		},
		{
			name: 'email-template',
			label: 'Email Template Image',
			value: 'Rate-004',
			id: 3,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1652737237/automated-email-templates/updated/600x600_-_Rate_Watch4.jpg',
		},
	],
	MarketWatch: [
		{
			name: 'u-connect-email-template',
			label: 'Email Template Image',
			value: 'Mark-001',
			id: 0,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1654255798/automated-email-templates/600x600_-_UConnect.jpg',
		},
		{
			name: 'u-connect-email-template',
			label: 'Email Template Image',
			value: 'Mark-002',
			id: 1,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1654255830/600x600_-_UConnect2.jpg',
		},
		{
			name: 'u-connect-email-template',
			label: 'Email Template Image',
			value: 'Mark-003',
			id: 2,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1654255841/600x600_-_UConnect3.jpg',
		},
		{
			name: 'u-connect-email-template',
			label: 'Email Template Image',
			value: 'Mark-004',
			id: 3,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1654255851/600x600_-_UConnect4.jpg',
		},
	],
	ReviewMe: [
		{
			name: 'review-me-email-template',
			label: 'Email Template Image',
			value: 'Review-001',
			id: 0,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1705951977/GoogleMyBusiness_ReviewMe1.png',
		},
		{
			name: 'review-me-email-template',
			label: 'Email Template Image',
			value: 'Review-002',
			id: 1,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1704911764/Review%20Me%20Email%20Templates/GoogleMyBusiness_ReviewMe2.png',
		},
		{
			name: 'review-me-email-template',
			label: 'Email Template Image',
			value: 'Review-003',
			id: 2,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1705951978/GoogleMyBusiness_ReviewMe3.png',
		},
		{
			name: 'review-me-email-template',
			label: 'Email Template Image',
			value: 'Review-004',
			id: 3,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1705951978/GoogleMyBusiness_ReviewMe4.png',
		},
	],
	EquityWatch: [
		{
			name: 'unite-email-template',
			label: 'Email Template Image',
			value: 'Eqty-001',
			id: 0,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1664801433/automated-email-templates/Unite_1_600x600v3.jpg',
		},
		{
			name: 'unite-email-template',
			label: 'Email Template Image',
			value: 'Eqty-002',
			id: 1,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1664801433/automated-email-templates/Unite_2_600x600v3.jpg',
		},
		{
			name: 'unite-email-template',
			label: 'Email Template Image',
			value: 'Eqty-003',
			id: 2,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1664801433/automated-email-templates/Unite_3_600x600v3.jpg',
		},
		{
			name: 'unite-email-template',
			label: 'Email Template Image',
			value: 'Eqty-004',
			id: 3,
			link: 'https://res.cloudinary.com/uwm/image/upload/v1664801433/automated-email-templates/Unite_4_600x600v3.jpg',
		},
	],
};
export const PC_ALERT_TOOLTIPS = {
	ReviewMe:
		'Alerts you 48 hours before your borrower is notified to leave you a review about their recent experience.',
	CreditWatch:
		"Alerts you when a borrower's credit score has improved above a target FICO.",
	EquityWatch:
		'Alerts you when a borrower has reached a certain amount of equity and gives you the estimated home value and current LTV.',
	MIDropEligible:
		"Alerts you when a borrower's LTV drops below 80% and is eligible to drop M.I.",
	MarketWatch: 'Alerts you when a borrower is shopping for a new mortgage.',
	NewListing: "Alerts you when a borrower's property is listed.",
	RateWatch: 'Alerts you when a lower rate is available to your borrower.',
	Birthday: 'Alerts you when a borrower is celebrating a birthday.',
	LoanAnniversary:
		'Alerts you when a borrower is celebrating a loan anniversary.',
};
export const PC_ALERT_NOTES = {
	ReviewMe:
		"Note: This alert is only available for contacts that have closed a loan with UWM and requires your company's Google My Business URL to be added to your Company Profile.",
	CreditWatch:
		'Note: This alert is only available for contacts that have closed a loan with UWM.',
	EquityWatch: 'Note: This alert is only available for loans closed with UWM.',
	MIDropEligible:
		'Note: This alert is only available for loans closed with UWM',
	NewListing: 'Note: This alert is only available for loans closed with UWM',
	MarketWatch: 'Note: This alert is only available for loans closed with UWM',
	RateWatch: 'Note: This alert is only available for loans closed with UWM',
};
export const PC_ALERT_NAME_LEGEND_LABEL = {
	ReviewMe: 'Review Me',
	CreditWatch: 'Credit Watch',
	EquityWatch: 'Unite',
	MIDropEligible: 'MI Drop Eligible',
	NewListing: 'New Listings',
	MarketWatch: 'UConnect',
	RateWatch: 'Rate Watch',
	Birthday: 'Birthday Watch',
	LoanAnniversary: 'Loan Anniversary Watch',
};

export function setClassNames(alertName) {
	switch (alertName) {
		case 'Birthday':
			return 'birthday';
		case 'RateWatch':
			return 'rate-watch';
		case 'EquityWatch':
			return 'unite';
		case 'LoanAnniversary':
			return 'loan-anniversary';
		case 'MarketWatch':
			return 'u-connect';
		case 'CreditWatch':
			return 'credit-watch';
		case 'NewListing':
			return 'new-listings';
		case 'MIDropEligible':
			return 'mi-drop-eligible';
		case 'ReviewMe':
			return 'review-me';
		default:
			return '';
	}
}

export function setAbbreviation(alertName) {
	switch (alertName) {
		case 'Birthday':
			return 'bw';
		case 'RateWatch':
			return 'rw';
		case 'EquityWatch':
			return 'un';
		case 'LoanAnniversary':
			return 'la';
		case 'MarketWatch':
			return 'uc';
		case 'CreditWatch':
			return 'cw';
		case 'NewListing':
			return 'nl';
		case 'MIDropEligible':
			return 'mi';
		case 'ReviewMe':
			return 'rm';
		default:
			return '';
	}
}
